
import { omega, params } from '@didi/driver-biz-sdk'
import { defineComponent, onBeforeUnmount } from '@vue/composition-api'
import { sendEseLeads } from '@/api/index'
import { isInApp } from '@/common/biz/constants'
export default defineComponent({
  name: 'foot-system-info',
  setup() {
    let dialog
    onBeforeUnmount(() => {
      dialog && dialog.hide()
    })
    function clickTel() {
      omega.trackEvent('am_c_insure_tasklist_tel_ck', {
        page_name: 'medical'
      })
      sendEseLeads({
        /**
         * 车险的几个页面是 1 2 3
         * 医疗 11
         * 养老 21
         */
        channel_id: 11
      }).finally(() => {
        window.location.href = `tel:${params.urlParams.tel ? params.urlParams.tel : '400-000-0666'}`
      })
    }
    return {
      clickTel,
      isInApp
    }
  }
})
